module.exports = __webpack_public_path__ + "img/Modernisme_Episk_litteratur1.772c0cc2.jpg";